/* Renact reveal-on-scroll
   Mirrors Lovable's `FadeSection` and `RevealText` (uses Framer Motion's
   useInView with margin "-60px" / "-80px"). One IntersectionObserver per
   class, attached on DOMContentLoaded.
*/
(function () {
  if (typeof window === 'undefined' || typeof IntersectionObserver === 'undefined') return;

  function observe(selector, rootMargin) {
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.setAttribute('data-visible', 'true');
            entry.target.classList.add('is-visible');
            io.unobserve(entry.target);
          }
        });
      },
      { rootMargin: rootMargin || '-60px 0px' }
    );
    document.querySelectorAll(selector).forEach(function (el) { io.observe(el); });
  }

  function init() {
    observe('.renact-fade-up', '-60px 0px');
    observe('.renact-reveal-text', '-80px 0px');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
